import { ReactElement } from 'react';
import { Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import theme from 'theme';
import externalLinks from 'services/routes/externalLocations';
import useStyles from '../style';

const LegalExternalLinks = (): ReactElement => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      {Object.values(externalLinks.legal).map((item) => (
        <Link
          key={item.label}
          href={item.url}
          className={classes.textBox}
          underline="none"
          py={isMobile ? 2 : 0}
          margin={theme.spacing(isMobile ? 1 : 4, 0)}
        >
          <Typography
            sx={{
              padding: theme.spacing(1, 0, 0.5),
              fontSize: 12,
              color: `${theme.palette.grey[50]}`,
              margin: 0,
            }}
          >
            {t(item.label)}
          </Typography>
        </Link>
      ))}
    </>
  );
};

export default LegalExternalLinks;
